import { useQuery } from "@tanstack/react-query"
import { queryKeys } from "../constants"
import { getAdventures, getAdventureImage, getUpcomingAdventure, getAdventure, getAdventuresOptions } from "../services/adventureService"
import { useContext } from "react";
import { GlobalStatesContext } from "../../context/globalStates.context";

export const useFetchAdventures = (startDate, endDate, difficulty, type, isChildFriendly, pageNumber = 1) => {
    const { searchTerm } = useContext(GlobalStatesContext);   
    const { data = [], isLoading } = useQuery({
        queryKey: [queryKeys.adventures, searchTerm, startDate, endDate, difficulty, type, isChildFriendly, pageNumber],
        queryFn: () => getAdventures(searchTerm, startDate, endDate, difficulty, type, isChildFriendly, pageNumber)
    })

    return { data, isLoading };
}

export const useFetchAdventuresOptions = () => {  
  const { data = [], isLoading } = useQuery({
      queryKey: [queryKeys.adventureOptions],
      queryFn: () => getAdventuresOptions()
  })

  return { data, isLoading };
};

export const useFetchAdventure = (advetureId) => { 
    const { data = [], isLoading } = useQuery({
        queryKey: [queryKeys.adventure, advetureId],
        queryFn: () => getAdventure(advetureId)
    })

    return { data, isLoading };
}

export const useFetchUpcomingAdventures = () => {   
    const { data = [], isLoading } = useQuery({
        queryKey: [queryKeys.upcomingAdventures],
        queryFn: () => getUpcomingAdventure()
    })

    return { data, isLoading };
}

export const useFetchAdventureImages = (adventureId, isDisplayImage) => {  
  const { data = [], isLoading } = useQuery({
      queryKey: [queryKeys.adventureImages, adventureId],
      queryFn: () => getAdventureImage(adventureId, isDisplayImage)
  })

  return { data, isLoading };
};